import React, { useState, useEffect } from "react";
import CKEditor from "ckeditor4-react";

const RichTextEditor = ({
  emailContent,
  handleChangeEmailContent,
  readOnly,
}) => {
  const [initialized, setInitialized] = useState(false);
  const ckEditorConfig = {
    versionCheck: false,
    extraPlugins:
      "indent,indentblock,indentlist,font,colorbutton,colordialog,table,tabletools,tableselection,tableresize,uploadimage,image,clipboard,justify,stylescombo,autogrow,liststyle,uploadimage,image,clipboard,lineutils,widget,uploadwidget,uploadfile,",
    toolbar: [
      ["FontSize", "TextColor", "BGColor"],
      ["Bold", "Italic", "Underline"],
      ["JustifyLeft", "JustifyCenter", "JustifyRight", "JustifyBlock"],
      ["Styles"],
      ["NumberedList", "BulletedList"],
      ["Format"],
      ["RemoveFormat"],
      ["Table"],
      ["TableProperties", "CellProperties"],
      ["MergeCells", "SplitCells"],
      ["Link", "Image", "PasteFromWord"],
      // ['CustomLinkBtn']
    ],
    indentOffset: 40,
    indentUnit: "px",
    indentClasses: [],
    indentStyles: { left: "margin-left", right: "margin-right" },
    indentBlock: {
      enabled: true,
      elements: ["p", "div", "h1", "h2", "h3", "h4", "h5", "h6"],
    },
    allowedContent: true,
    extraAllowedContent:
      "p[style]; div[style]; h1[style]; h2[style]; h3[style]; ul[style]; ol[style]; li[style]; span[style]",
    justifyClasses: [null, null, null, null],
    format_ul: { element: "ul", attributes: { class: "list-disc" } },
    format_ol: { element: "ol", attributes: { class: "list-decimal" } },
    // uploadUrl: '/api/upload/image',
    // imageUploadUrl: '/api/upload/image',
    table_defaultAttributes: {
      border: "1",
      width: "100%",
      align: "center",
    },
    colorButton_colors: "FF0000,00FF00,0000FF,FFFF00",
    colorButton_enableAutomatic: false,
    autoGrow_minHeight: 200,
    autoGrow_maxHeight: 800,
    autoGrow_bottomSpace: 50,
    autoGrow_onStartup: true,
    removePlugins: "resize,elementspath,uploadimage,uploadfile",
  };

  return (
    <div className="email-editor-wrapper">
      <CKEditor
        data={emailContent}
        onInstanceReady={(evt) => {
          setInitialized(true);
          if (readOnly) {
            evt.editor.setReadOnly(true);
          }
        }}
        onChange={(evt) => {
          if (!initialized) return;
          if (readOnly) return;
          const html = evt.editor.getData();
          handleChangeEmailContent(html);
        }}
        config={ckEditorConfig}
      />
    </div>
  );
};

export default RichTextEditor;
